import React from 'react';
import { useEffect, useState } from 'react';
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';


const BiassesProducteurs = ({ bParticipants, userId }) => {
    const [producteurs, setProducteurs] = useState([]);

    useEffect(() => {
        // Sécurité si aucun participant n'est inscrit
        if (!bParticipants || bParticipants.length === 0) {
            setProducteurs([]);
            return;
        }

        const headers = new Headers();
        headers.append('cle', cle_COURTJUS);

        // Si bParticipants arrive sous forme de tableau du parent, on l'aligne pour l'API
        const participantsQuery = Array.isArray(bParticipants)
            ? bParticipants.join(',')
            : bParticipants;

        fetch(`${URL_COURTJUS_BACK}/usersin/${participantsQuery}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (Array.isArray(res)) {
                    // CORRECTION : On stocke l'objet complet pour garder l'accès à uNum
                    setProducteurs(res);
                }
            })
            .catch(err => console.error("Erreur récupération participants:", err));

        // REQUIS : On écoute bParticipants pour que la liste se mette à jour dès qu'on clique sur le bouton radio !
    }, [bParticipants]);

    return (
        <p>
            {producteurs.map((prod, i) => {
                // Vérification de sécurité de type (Nombre ou Chaîne)
                const isCurrentUser = String(prod.uNum) === String(userId);

                // On applique une classe CSS conditionnelle (ex: 'biasse-list-particip-self' pour vous)
                const className = `biasse-list-particip ${isCurrentUser ? 'biasse-list-particip-self' : ''}`;

                return (
                    <span className={className} key={prod.uNum || i}>
                        {prod.uStructure} ({prod.uNom} {prod.uPrenom})
                    </span>
                );
            })}
        </p>
    );
};

export default BiassesProducteurs;